'use client';

export default function selectStorage(storage: 'local' | 'session') {
  if (typeof window === 'undefined') {
    throw new Error('selectStorage can only be used in the browser');
  }

  return window[`${storage}Storage`];
}
